export const getClientData = ({ clients }) => clients.client;
export const getSuccess = ({ clients }) => clients.success.success;
export const getClientLoading = ({ clients }) => clients.loaders.common;
export const getError = ({ clients }) => clients.errors.error;
